<template>
  <div class="page-container has-action">
    <van-nav-bar
      left-arrow
      fixed
      :z-index="10"
      @click-left="goableBack()"
      title="绑定银行卡"></van-nav-bar>

    <div class="block realname">
      <van-field
        v-model="form.field.name"
        label="真实姓名"
        placeholder="请输入真实姓名"
        @blur="!readonly && checkRealName()"
        input-align="right"
        :readonly="readonly || (userInfo && userInfo.isAuthName)" />
      <van-field
        v-model="form.field.idNumber"
        label="身份证号"
        placeholder="请输入身份证号"
        @blur="!readonly && checkIdNum()"
        input-align="right"
        :readonly="readonly || (userInfo && userInfo.isAuthName)" />
    </div>
    <div class="block mt-5">
      <van-field
        type="number"
        v-model="form.field.cardNo"
        clearable
        :readonly="readonly"
        label="银行卡号"
        placeholder="请输入银行卡号"
        @blur="!readonly && checkCardNo()"
        input-align="right" />
      <van-field
        v-model="form.bankName"
        clearable
        label="开户行"
        placeholder="请选择开户行"
        @click="bankPicker.show = true && !readonly"
        right-icon="arrow-down"
        input-align="right"
        readonly />
      <van-field
        type="number"
        v-model="form.field.mobile"
        clearable
        label="手机号"
        placeholder="请输入手机号"
        @blur="!readonly && checkMobile()"
        input-align="right"
        :readonly="readonly" />
    </div>
    <div class="page-action">
      <van-button
        @click="submit"
        :loading="form.loading"
        type="danger"
        size="large"
        loading-text="提交中..."
        :disabled="form.disabled"
        >确认</van-button
      >
    </div>

    <van-popup v-model="bankPicker.show" position="bottom">
      <van-picker
        show-toolbar
        value-key="bankName"
        :columns="bankPicker.columns"
        :loading="bankPicker.loading"
        @cancel="bankPicker.show = false"
        @confirm="confirmBankPicker" />
    </van-popup>
  </div>
</template>
<script>
import {
  NavBar,
  CellGroup,
  Field,
  Button,
  Toast,
  Dialog,
  Picker,
  Popup
} from "vant"
import * as PayApi from "@/api/pay"
import * as BankCardApi from "@/api/bankcard"
import * as CustApi from "@/api/cust"
import * as validate from "@/utils/validate"
import session from "@/utils/session"

import { mapGetters, mapMutations } from "vuex"
export default {
  name: "index",

  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [NavBar.name]: NavBar,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Popup.name]: Popup,
    [Picker.name]: Picker
  },

  data: () => ({
    readonly: false,
    redirect: false,
    bankPicker: {
      show: false,
      loading: false,
      columns: []
    },
    payForm: {},
    form: {
      disabled: false,
      bankName: "",
      field: {
        idNumber: "",
        name: "",
        cardNo: "",
        bankId: "",
        mobile: "",
        terminal: "H5"
      },
      validate: {
        idNumber: null,
        name: null,
        cardNo: null,
        bankId: null,
        mobile: null
      },
      message: {
        idNumber: "请输入正确的身份信息",
        name: "请输入正确的身份信息",
        cardNo: "请输入正确的银行卡信息",
        bankId: "请输入正确的银行卡信息",
        mobile: "请输入正确的手机号信息"
      },
      prop: {
        idNumber: {
          ignore: true
        },
        name: {
          ignore: true
        },
        cardNo: {
          readonly: false,
          ignore: false
        },
        bankId: {
          readonly: false,
          ignore: false
        },
        mobile: {
          readonly: false,
          ignore: false
        }
      }
    }
  }),

  beforeMount() {
    let p1, p2
    p1 = PayApi.banklist()
    if (this.channel.toLowerCase() == "yt") {
      p2 = CustApi.getchanlbindinfo()
    }

    Promise.all([p1, p2]).then((data) => {
      this.bankPicker.columns = data[0] || []
      if (data[1]) {
        this.readonly = true
        this.form.field.name = data[1].name
        this.form.field.idNumber = data[1].idNumber
        this.form.field.cardNo = data[1].cardNo
        this.form.field.mobile = data[1].mobile
        this.form.field.bankId = data[1].bankId
        this.form.validate.name = true
        this.form.validate.idNumber = true
        this.form.validate.cardNo = true
        this.form.validate.mobile = true
        this.form.validate.bankId = true

        if (this.form.field.bankId) {
          let bank = this.bankPicker.columns.find((n) => {
            return n.id == this.form.field.bankId
          })
          this.form.bankName = bank.bankName
        }
      } else if (this.userInfo.isAuthName) {
        this.form.validate.idNumber = true
        this.form.validate.name = true
        this.form.field.name = this.userInfo.name
        this.form.field.idNumber = this.userInfo.idNumber
      }
    })

    this.redirect = this.$route.query.redirect
  },
  methods: {
    validateForm() {
      for (let item in this.form.validate) {
        console.log(this.form.validate[item])
        if (!this.form.validate[item]) {
          Toast(this.form.message[item])
          return item
        }
      }
      return true
    },

    submit() {
      let validated = this.validateForm()
      let sendForm = Object.assign(
        {},
        JSON.parse(JSON.stringify(this.form.field))
      )
      let external = session.get("external")
      if (validated !== true) return
      this.form.disabled = true
      if (this.userInfo && this.userInfo.isAuthName) {
        delete sendForm.name
        delete sendForm.idNumber
      }
      this._showLoading()
      BankCardApi.bindBankCard(sendForm)
        .then((data) => {
          this._dismissLoading()
          console.log("绑卡结果:%O", data)
          CustApi.userInfo()
            .then((info) => {
              this.setUserInfo(info)
              setTimeout(() => {
                this.pop(external)
              }, 500)
            })
            .catch((ex) => {
              Toast("更新用户信息失败")
              setTimeout(() => {
                this.$router.push({ path: "/user" })
              }, 2000)
            })
          let query = session.getJson("cq")
          if (external === "1") {
            if (query.target === "bindcard") {
              Toast.success("绑定成功")
            } else {
              return this.$router.replace({ name: "callback", query: query })
            }
          } else {
            if (query) {
              return this.$router.replace({ name: query.target, query: query })
              session.del("cq")
            } else {
              return this.$router.replace({ name: "cardlist" })
            }
          }
        })
        .catch((e) => {
          this.form.disabled = false
          this._dismissLoading()
          Toast(e.msg || e.message)
        })
    },
    pop(external) {
      let query = session.getJson("cq")
      if (external === "1") {
        if (query.target === "bindcard") {
          Toast.success("绑定成功")
        } else {
          return this.$router.replace({ name: "callback", query: query })
        }
      } else {
        if (query) {
          return this.$router.replace({ name: query.target, query: query })
          session.del("cq")
        } else {
          return this.$router.replace({ name: "cardlist" })
        }
      }
    },
    checkRealName() {
      if (validate.realName(this.form.field.name)) {
        this.form.validate.name = true
      } else {
        this.form.validate.name = false
        Toast("请输入真实姓名")
      }
    },
    checkIdNum() {
      if (validate.idNum(this.form.field.idNumber)) {
        this.form.validate.idNumber = true
      } else {
        this.form.validate.idNumber = false
        Toast("身份证号不正确")
      }
    },
    checkMobile() {
      if (validate.mobile(this.form.field.mobile)) {
        this.form.validate.mobile = true
      } else {
        this.form.validate.mobile = false
        Toast("手机号不正确")
      }
    },
    checkCardNo() {
      if (
        validate.num(this.form.field.cardNo) &&
        this.form.field.cardNo.length >= 15
      ) {
        this.form.validate.cardNo = true

        //根据卡号获取开户行
        /*BankCardApi.getBankCardBin(this.form.field.cardNo).then(data => {
                    this.form.prop.cardNo.readonly = false;
                    console.info(data);
                }).catch(e => {
                    this.form.prop.cardNo.readonly = false;
                });*/
      } else {
        this.form.validate.cardNo = false
        Toast("请输入正确的银行卡信息")
      }
    },
    checkBankId() {
      if (this.form.field.bankId) {
        this.form.validate.bankId = true
      } else {
        this.form.validate.bankId = false
      }
    },
    confirmBankPicker(value) {
      this.form.bankName = value.bankName
      this.form.field.bankId = value.id
      this.bankPicker.show = false
      this.checkBankId()
    },
    ...mapMutations(["setUserInfo"])
  },
  computed: {
    ...mapGetters(["userInfo", "channel"])
  }
}
</script>

<style lang="less" scoped>
</style>